export default "/images/mercadolibre.png?d934f539fabbc16c264c6e2140c2dacb";